import { WarningOutlined } from '@ant-design/icons';
import { Carousel, Tooltip } from 'antd';
import React from 'react';
import './index.scss';

export const WarningDeviceWindow = ({ device }) => {
  return (
    <div className="warning-device-wrapper">
      <Carousel autoplay={true}>
        {(device?.thumbnails || []).map((item, idx) => {
          return (
            <img key={idx} width={150} src={item} alt="device thumbnail" />
          );
        })}
      </Carousel>
      <div className="detail-camera">
        <div className="warning-text">
          <WarningOutlined /> Device disconnected
        </div>
        <Tooltip title={device.name}>
          <div className="name">{device.name}</div>
        </Tooltip>

        <Tooltip title={device.note}>
          <div className="address">{device.note}</div>
        </Tooltip>
      </div>
    </div>
  );
};

export default WarningDeviceWindow;
